export const ImportCSVMaxFileSize = 25000000
export const MaxImageFileSize = 1024000
export const MaxFileNameLength = 200
export const MaxLogoImageWidth = 200
export const MaxLogoImageHeight = 100
export const MaxInvitationAttempts = 5
export const MaxFailedLoginAttempts = 4
export const AccountLimit = 10
export const EmailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const PhoneRegexp = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/
export const NameRegexp = /^[a-zA-Z0-9 '.-]*$/
export const CompanyNameRegexp = "^[a-zA-Z0-9-.,' ]*$"
export const MaxDonorIdLength = 25
export const InvalidDonorIdLength = `Donor ID should contain 1 - ${MaxDonorIdLength} characters.`
export const DonorIdRegexp = /^[^ '-]*$/
export const InvalidDonorId = "Spaces, apostrophes and hyphens are not allowed."
export const IntlPhoneRegexp11 = /^[0-9]{1}-[0-9]{3}-[0-9]{3}-[0-9]{4}$/
export const ZipRegexp = /^[0-9]{5}$/
export const CamelCaseRegexp = /([a-z])([A-Z])/g
export const SiteDomain = "workforce-stage.clinholdco.com"
export const ProtectedSites = ["aol", "att", "bellsouth", "comcast", "earthlink", "frontier", "gmail", "hotmail", "imail", "mail", "msn", "outlook", "qwestoffice", "sbcglobal", "windstream", "yahoo"]
export const ReCaptchaSiteKey = "6LdVBnAUAAAAAOqWTjak57WEmTJb6-rELjtqT4nr"  // TODO: Workforce 1.0 production
export const GMapApiKey = "AIzaSyBk9jTuJa7GYll5lkPO5xYbM8TkxKvab2A"
export const DefaultMapLatitude = 40.4402885
export const DefaultMapLongitude = -99.36982169999999
export const UpdateMethodID = 1 // Kyle: This turned out to be hardcoded as a 1.
export const AccountTypeID = 2
export const RpAccountType = 2
export const ImplementationGroupID_Workforce = 3
export const IpifyUrl = "https://api.ipify.org?format=json"
export const WorkForceLogo = "/images/Logo/formfox.png"
export const QuickStartLogo = "/images/Logo/quickstart.png"
export const LabAccountMaxLength = 30
export const InvalidNameMessage = "Only letters, digits, spaces, dots, apostrophes and hyphens are allowed."
export const DisabledDefaultOrderableService = "This is default service and cannot be removed for Company. Please remove this service as a default for Portal to allow editing on Company level."
export const ImplementationTypeGovt = "GOVT"
export const MinDate = 1
export const MaxDateWeekly = 7
export const MaxDateMonthly = 31
export enum StorageKey {
  SavedOrderData = "savedOrderData",
  OrderedServices = "servicesBeingOrdered",
  OrderDonorSiteSelect = "orderDonorSiteSelect",
  CanViewOrderFinish = "canViewOrderFinish",
  FromSelectionInbox = "fromSelectionInbox",
  OrderTrackingGridColumns = "orderTrackingGridColumns",
  PoolMembersGridColumns = "poolMembersGridColumns",
  RandomPersonnelGridColumns = "randomPersonnelGridColumns",
  SelectionInboxGridColumns = "selectionInboxGridColumns",
  ImplementationType = "implementationType",
  CachedCollectionTests = "cachedCollectionTests",
  InvitationStatusGridColumns = "invitationStatusGridColumns"
}
export enum EventType {
  Breath = "BR",
  Saliva = "SL",
  Urine = "UR",
  UrinePOCT = "QT",
  SalivaDrug = "SLD",
  SalivaDrugPOCT = "QTS",
}
export enum ClinicStatus {
  UserConfigured = 9,
  ClinicConfigured = 10,
  ClientConfigured = 11,
  Completed = 12
}

export enum ScheduleStatus {
  Cancelled = 11
}

export enum AccountType {
  MasterAccount = 1,
  Company = 2,
  Region = 3,
  Location = 4
}